import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import styles from './Common.module.css';
import { PatientCareCenterNoteSection } from 'PatientCareCenter/Note';
import { DBCheckBox, DBRadioButton, DBTextArea, DBTextField } from '_components';


class PatientCareCenterNoteAssessmentBarriers extends React.Component {

    handleNoneClick(val) {
        if (val) {
            let fields = ['ASBARRIERATTEND',
                'ASBARRIERCOMPLIANCE',
                'ASBARRIERMEDICAL',
                'ASBARRIERPSYCHO',
                'ASBARRIEROTHER',
                'ASBARRIEROTHERTXT',
                'ASBARRIERRESOLVED',
                'ASBARRIERDETAILS'
            ];
            this.props.clearFields(this.props.noteId, 'PTASSESSMENT', 'ASNO', this.props.asno, fields);
        }
    }

    handleOtherClick(val) {
        if (val === false && this.props.otherText !== null) {
            this.props.clearField(this.props.noteId, 'PTASSESSMENT', 'ASNO', this.props.asno, 'ASBARRIEROTHERTXT');
        }
    }

    render() {
        return (
            <PatientCareCenterNoteSection id='assessment_barriers' name='Barriers to Progress' level={1}>
                <div className={styles.row}>
                    <span className={styles.col1}>
                        <div className={styles.required}>Check all that apply:</div>
                        <div className={styles.checkbox_barriers}>
                            <DBCheckBox
                                noteId={this.props.noteId}
                                entity='PTASSESSMENT'
                                entityKeyColumn='ASNO'
                                entityKeyValue={this.props.asno}
                                field='ASBARRIERNONE'
                                label='None'
                                onClick={(event) => this.handleNoneClick(event)}
                            />
                        </div>
                        {!this.props.noneSelected &&
                            <span>
                                <div className={styles.checkbox_barriers}>
                                    <DBCheckBox
                                        noteId={this.props.noteId}
                                        entity='PTASSESSMENT'
                                        entityKeyColumn='ASNO'
                                        entityKeyValue={this.props.asno}
                                        field='ASBARRIERATTEND'
                                        label='Attendance Issues'
                                    />
                                </div>
                                <div className={styles.checkbox_barriers}>
                                    <DBCheckBox
                                        noteId={this.props.noteId}
                                        entity='PTASSESSMENT'
                                        entityKeyColumn='ASNO'
                                        entityKeyValue={this.props.asno}
                                        field='ASBARRIERCOMPLIANCE'
                                        label='Compliance Issues'
                                    />
                                </div>
                                <div className={styles.checkbox_barriers}>
                                    <DBCheckBox
                                        noteId={this.props.noteId}
                                        entity='PTASSESSMENT'
                                        entityKeyColumn='ASNO'
                                        entityKeyValue={this.props.asno}
                                        field='ASBARRIERMEDICAL'
                                        label='Medical Issues'
                                    />
                                </div>
                                <div className={styles.checkbox_barriers}>
                                    <DBCheckBox
                                        noteId={this.props.noteId}
                                        entity='PTASSESSMENT'
                                        entityKeyColumn='ASNO'
                                        entityKeyValue={this.props.asno}
                                        field='ASBARRIERPSYCHO'
                                        label='Psychosocial Issues'
                                    />
                                </div>
                                <div className={styles.checkbox_barriers}>
                                    <DBCheckBox
                                        noteId={this.props.noteId}
                                        entity='PTASSESSMENT'
                                        entityKeyColumn='ASNO'
                                        entityKeyValue={this.props.asno}
                                        field='ASBARRIEROTHER'
                                        label='Other'
                                        onClick={(event) => this.handleOtherClick(event)}
                                    />
                                    {this.props.otherSelected &&
                                        <DBTextField
                                            noteId={this.props.noteId}
                                            entity='PTASSESSMENT'
                                            entityKeyColumn='ASNO'
                                            entityKeyValue={this.props.asno}
                                            field='ASBARRIEROTHERTXT'
                                            className={styles.barriers_other}
                                        />
                                    }
                                </div>
                            </span>
                        }
                    </span>
                    <span className={styles.col2}>
                        {this.props.showDetails &&
                            <span>
                                <div className={styles.row}>
                                    <label className={styles.required}>Details about barrier and resolution:</label>
                                </div>
                                <div className={styles.row}>
                                    <DBTextArea
                                        noteId={this.props.noteId}
                                        entity='PTASSESSMENT'
                                        entityKeyColumn='ASNO'
                                        entityKeyValue={this.props.asno}
                                        field='ASBARRIERDETAILS'
                                        rows={5}
                                        className={styles.barrier_textarea}
                                    />
                                </div>
                            </span>
                        }
                    </span>
                </div>

            </PatientCareCenterNoteSection>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        clearFields: bindActionCreators(noteActions.clearFields, dispatch),
        clearField: bindActionCreators(noteActions.clearField, dispatch)
    };
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let asno = parseInt(Object.keys(state.entities.notes.PTASSESSMENT)
        .find(key => (state.entities.notes.PTASSESSMENT[key].ASEVNO === pk && noteType === 1)
        || (state.entities.notes.PTASSESSMENT[key].ASNTNO === pk && noteType !== 1)));

    let noneSelected = state.entities.notes.PTASSESSMENT[asno]?.ASBARRIERNONE;
    let otherText = state.entities.notes.PTASSESSMENT[asno]?.ASBARRIEROTHERTXT;
    let otherSelected = state.entities.notes.PTASSESSMENT[asno]?.ASBARRIEROTHER;
    let showDetails = state.entities.notes.PTASSESSMENT[asno]?.ASBARRIERATTEND ||
        state.entities.notes.PTASSESSMENT[asno]?.ASBARRIERCOMPLIANCE ||
        state.entities.notes.PTASSESSMENT[asno]?.ASBARRIERMEDICAL ||
        state.entities.notes.PTASSESSMENT[asno]?.ASBARRIERPSYCHO ||
        state.entities.notes.PTASSESSMENT[asno]?.ASBARRIEROTHER ? true : false;

    return {
        noteId,
        noteType,
        asno,
        otherText,
        otherSelected,
        noneSelected,
        showDetails
    };
}

const connectedPatientCareCenterNoteAssessmentBarriers = connect(mapStateToProps, mapDispatchToProps)(PatientCareCenterNoteAssessmentBarriers);
export { connectedPatientCareCenterNoteAssessmentBarriers as PatientCareCenterNoteAssessmentBarriers };

